<div class="bg-white border border-gray-200 rounded-lg text-sm">
  <div class="p-3 flex items-center bg-gray-100">
    <div class="flex gap-2 items-center flex-auto" cdkDragHandle>
      <mat-icon>record_voice_over</mat-icon>

      <span class="font-medium">Ga naar interactie</span>
    </div>

    <div class="flex">
      <ng-template
        [ngTemplateOutlet]="actions() ?? null"
        [ngTemplateOutletContext]="{ $implicit: data() }"
      />
    </div>
  </div>

  <div class="p-3 border-t border-inherit">
    <span
      class="truncate w-min max-w-40 truncate inline-block align-middle"
      [matTooltip]="data().value.label"
      matTooltipPosition="after"
    >
      {{ data().value.label }}
    </span>
    <span
      class="bg-gray-300 text-gray-800 py-1 px-2 rounded-full text-xs font-medium align-middle ml-1"
      >v{{ data().value.version }}</span
    >
  </div>
</div>
